export type HapticStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'

/** Возвращает Telegram WebApp API, либо null вне Telegram. */
export function getWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null
}

/** True, когда Mini App открыт внутри Telegram WebView. */
export function isInTelegram(): boolean {
  return Boolean(getWebApp()?.initData)
}

/** Telegram требует вызвать ready()/expand() при старте Mini App. */
export function initTelegram(): void {
  const wa = getWebApp()
  if (!wa) return

  try {
    wa.ready()
    wa.expand()
    const bg = wa.themeParams?.bg_color ?? '#0a0f1a'
    wa.setHeaderColor(bg)
    wa.setBackgroundColor(bg)
  } catch {
    // Не критично — продолжаем без кастомизации Telegram.
  }
}

/** Запросить полноэкранный режим на iPad/планшетах и поддерживаемых клиентах. */
export function requestExpandedView(): void {
  const wa = getWebApp()
  if (!wa) return
  try {
    if (wa.requestFullscreen && (!wa.isVersionAtLeast || wa.isVersionAtLeast('8.0'))) {
      wa.requestFullscreen()
      return
    }
    wa.expand()
  } catch {
    // Старые клиенты Telegram не знают fullscreen — оставляем обычный expand.
    try { wa.expand() } catch { /* client rejected the request */ }
  }
}

export function haptic(style: HapticStyle = 'light'): void {
  try {
    getWebApp()?.HapticFeedback?.impactOccurred(style)
  } catch {
    // Haptics не обязательны.
  }
}

/** Открыть ссылку наружу: через Telegram WebApp или новым окном браузера. */
export function openExternal(url: string): void {
  const wa = getWebApp()
  if (wa) {
    wa.openLink(url)
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}
